// eslint-disable-next-line import/prefer-default-export
export const AgentFilterValues = Object.freeze({ All: false, Mine: true})
